import { VideoType } from '../Types/Video.types';
import { lazy } from 'yup';
import { object, string, number } from 'yup';
import { embedCodePattern, isValidVideoSource } from '../videoUrlPatterns';

export const VIDEO_SCHEMA = object({
	unit: object({
		course_id: number().required(),
		type_id: number().required(),
		name: string().required(),
		order: number().notRequired(),
	}),
	video: object({
		name: string().notRequired(),
		uri: lazy((value) =>
			/<(\"[^\"]*\"|'[^']*'|[^'\">])([a-zA-Z]+)(?:[^>]*[^/]*)?>$/.test(value)
				? string()
						.matches(embedCodePattern, 'Embed Link is not valid')
						.required()
						.typeError('Embed Link is required')
				: string()
						.required()
						.typeError('Video URL is required')
						.test(
							'video-source',
							'Enter a valid video URL or a VdoCipher video ID',
							(value) => !!value && isValidVideoSource(String(value))
						)
		),
		duration: number()
			.required()
			.typeError('must be a number')
			.nullable()
			.transform((value, originalValue) =>
				String(originalValue).trim() === '' ? null : value
			),
		max_plays: number()
			.optional()
			.nullable()
			.transform((value, originalValue) =>
				String(originalValue).trim() === '' ? null : value
			),
	}),
	link_schema: string().notRequired(),
});

/**
 * The Save buttons submit `getValues()`, so the yup transforms above never
 * run and number inputs arrive as strings. Normalises them: an empty
 * max_plays means unlimited and is sent as null (so an existing limit can be
 * cleared — '' was silently dropped server-side); duration is required.
 * Returns null when duration is missing.
 */
export const normalizeVideoNumbers = (form: VideoType): VideoType | null => {
	const blank = (value: unknown) => value === undefined || value === null || String(value).trim() === '';
	const { duration, max_plays } = form.video as { duration: unknown; max_plays: unknown };
	if (blank(duration) || Number.isNaN(Number(duration))) return null;
	return {
		...form,
		video: {
			...form.video,
			duration: Number(duration),
			max_plays: blank(max_plays) ? null : Number(max_plays),
		},
	};
};
